import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProvisioningSessionService } from '../services';
import { getProvisioningStepRedirect } from './session-step-guard.util';

@Injectable({
  providedIn: 'root',
})
export class SessionAddonGuard implements CanActivate {
  private sessionSvc = inject(ProvisioningSessionService);
  private router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const session = await firstValueFrom(this.sessionSvc.getCurrentSession());
    const redirect = getProvisioningStepRedirect(route, session, 'addon');
    if (redirect) return this.router.createUrlTree(redirect, { queryParams: route.queryParams });
    return true;
  }
}
